import React from "react";

export default class HeatStroke extends React.Component {
  render() {
    return (
      <>
        <h3>Symptoms</h3>
        <p>
          Red skin, high body temperature (above 38-39 st. Celcius), hot and
          sweathy skin, nausea, notably increased pulse, thirst.
        </p>
        <h3>What to do?</h3>
        <ul>
          <li>
            Move/lead a person into shade. Lay the person in a halfsitting
            position and remain accompanying.
          </li>
          <li>Try different ways to cool the body.</li>
          <li>
            Give to drink water with vitamines and electrolites, but avoid
            giving too much water without nutrition value - it could lead to
            increased depletion of electrolites from the body.
          </li>
          <li>
            If you are in a club, the best way is to find a secluded space or go
            outside.
          </li>
          <li>
            Never administer any antifever medication, cooling down temperature
            should be done only mechanicaly - through a cold (but not ice cold)
            shower, cold compress on the forehead, neck or around groins.
          </li>
          <li>
            It's neceseray to observe the person through the whole time and
            regularly check up on breathing and circulation.
          </li>
        </ul>
      </>
    );
  }
}
